import { useSiteContent } from "@/lib/SiteContentProvider";
import Reveal from "@/components/site/Reveal";

/**
 * CredibilityStrip — minimal, generous, bright. One stat is dramatically
 * larger than the others (Taste hierarchy / anti-3-equal-cards), with a
 * quiet "trusted by" line. Numbers come straight from the CMS (never faked).
 */
export const CredibilityStrip = () => {
    const { data } = useSiteContent();
    const stats = data?.stats?.items || [];
    const [feature, ...rest] = stats;
    const brands = (data?.work_history?.collab_brands || [])
        .slice(0, 10)
        .map((b) => (typeof b === "string" ? b : b.name));

    return (
        <section
            className="pg-section pg-surface-bright"
            data-testid="home-credibility"
            aria-label="Studio credibility"
            style={{ paddingTop: "clamp(3.5rem,6vw,6rem)", paddingBottom: "clamp(3.5rem,6vw,6rem)" }}
        >
            <div className="pg-container">
                <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-12 lg:gap-16">
                    {feature && (
                        <Reveal className="lg:col-span-6">
                            <span className="pg-eyebrow">By the numbers</span>
                            <div className="mt-5 font-display-max leading-[0.9] pg-text-gold-static text-[clamp(4.5rem,12vw,9rem)]">
                                {feature.value}
                            </div>
                            <div className="mt-3 max-w-sm text-base" style={{ color: "var(--pg-fg-muted)" }}>
                                {feature.label}
                            </div>
                        </Reveal>
                    )}

                    <Reveal delay={0.08} className="lg:col-span-6">
                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
                            {rest.map((s, i) => (
                                <div key={i} className="border-t pt-5" style={{ borderColor: "var(--pg-border-strong)" }}>
                                    <div className="font-display text-[clamp(2.4rem,5vw,3.4rem)] leading-none" style={{ color: "var(--pg-fg)" }}>
                                        {s.value}
                                    </div>
                                    <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.22em]" style={{ color: "var(--pg-fg-muted)" }}>
                                        {s.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>

                {brands.length > 0 && (
                    <Reveal delay={0.12} className="mt-14">
                        <div className="flex flex-wrap items-center gap-x-7 gap-y-3">
                            <span className="font-mono text-[11px] uppercase tracking-[0.22em]" style={{ color: "var(--pg-fg-muted)" }}>
                                Trusted by
                            </span>
                            {brands.map((n, i) => (
                                <span key={i} className="font-display text-base sm:text-lg" style={{ color: "var(--pg-fg)", opacity: 0.7 }}>
                                    {n}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                )}
            </div>
        </section>
    );
};

export default CredibilityStrip;
